import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { fetchSerialNumberLocators } from '@gn-audio/core/api/knowledge-base/fetch-serial-number-locators';
import { getProductCatalogueApiConfig } from '@gn-audio/core/api/product-catalogue';
import { fetchGroup, fetchGroupFeatures } from '@gn-audio/core/api/product-catalogue';
import { Component, Inject, Input } from 'angular-ts-decorators';
import { PfmMode } from '../models';
import { getAttributeValue } from '../utils/get-attribute-value';
import template from './product-item.component.html';
var ProductItemComponent = (function () {
    function ProductItemComponent($q) {
        this.$q = $q;
        this.showSpecialOffers = false;
    }
    ProductItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.isGroupType && getProductCatalogueApiConfig().isSFCCSearchOn) {
            this.$q.when(this.populateProductWithAdditionalInfo())
                .then(function () { _this.initialize(); });
        }
        else {
            this.initialize();
        }
    };
    ProductItemComponent.prototype.initialize = function () {
        var _this = this;
        if (this.hasSupportUrl && this.isGroupType) {
            var _a = this.product, hasBluetoothPairingGuide = _a.hasBluetoothPairingGuide, supportPageUrl_1 = _a.supportPageUrl;
            var _b = this.product, groupId = _b.groupId, sku_1 = _b.sku;
            if (this.isSupportMode) {
                this.$q.when(fetchSerialNumberLocators(groupId))
                    .then(function (serialNumberLocators) {
                    if (serialNumberLocators === void 0) { serialNumberLocators = []; }
                    if (!(serialNumberLocators === null || serialNumberLocators === void 0 ? void 0 : serialNumberLocators.length)) {
                        return;
                    }
                    _this.serialNumberLocatorUrl = supportPageUrl_1 + "#/SERVICES#" + sku_1;
                });
            }
            if (this.isBluetoothPairingGuideMode && hasBluetoothPairingGuide) {
                this.bluetoothPairingGuideUrl = supportPageUrl_1 + "/" + sku_1 + "/get-started#BTPG";
            }
        }
    };
    Object.defineProperty(ProductItemComponent.prototype, "hasProduct", {
        get: function () {
            return Boolean(this.product);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "productId", {
        get: function () {
            if (!this.hasProduct) {
                return 0;
            }
            return this.isGroupType ? this.product.groupId : this.product.familyId;
        },
        enumerable: false,
        configurable: true
    });
    ProductItemComponent.prototype.productUrl = function () {
        if (!this.hasProduct) {
            return 'javascript:;';
        }
        switch (this.mode) {
            case PfmMode.Normal:
            case PfmMode.Compare:
                return this.product.pageUrl;
            case PfmMode.BluetoothPairingGuide:
                return this.bluetoothPairingGuideUrl;
            default:
                return this.product.supportPageUrl;
        }
    };
    ProductItemComponent.prototype.onPriceLoaded = function (price) {
        this.price = price;
    };
    Object.defineProperty(ProductItemComponent.prototype, "isFamilyType", {
        get: function () {
            return this.productType === "f";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isGroupType", {
        get: function () {
            return this.productType === "g";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isNormalMode", {
        get: function () {
            return this.mode === PfmMode.Normal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isBluetoothPairingGuideMode", {
        get: function () {
            return this.mode === PfmMode.BluetoothPairingGuide;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isContactSupportMode", {
        get: function () {
            return this.mode === PfmMode.ContactSupport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isSupportMode", {
        get: function () {
            return this.mode === PfmMode.Support;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "isCompareMode", {
        get: function () {
            return this.mode === PfmMode.Compare;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "hasHappyFoxId", {
        get: function () {
            return this.happyFoxId !== 0;
        },
        enumerable: false,
        configurable: true
    });
    ProductItemComponent.prototype.happyFoxWebformUrl = function () {
        var _this = this;
        if (!this.hasHappyFoxId) {
            return 'javascript:;';
        }
        if (!Array.isArray(this.contactSupportConfigurations)) {
            return 'javascript:;';
        }
        var webFormConfiguration = this.contactSupportConfigurations
            .filter(function (c) {
            return (!c.segmentType || c.segmentType === _this.product.segmentType) &&
                (!c.productType || c.productType === getAttributeValue(_this.product.attributes, "Meta_Producttype"));
        })[0];
        if (!webFormConfiguration) {
            return 'javascript:;';
        }
        return webFormConfiguration.webFormUrl + "?happyFoxId=" + this.happyFoxId + "&productId=" + this.productId;
    };
    Object.defineProperty(ProductItemComponent.prototype, "happyFoxId", {
        get: function () {
            var happyFoxId = getAttributeValue(this.product.attributes, "meta_happyfoxproductid");
            return Number(happyFoxId) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductItemComponent.prototype, "hasSupportUrl", {
        get: function () {
            var _a;
            return this.hasProduct && Boolean((_a = this.product) === null || _a === void 0 ? void 0 : _a.supportPageUrl);
        },
        enumerable: false,
        configurable: true
    });
    ProductItemComponent.prototype.populateProductWithAdditionalInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var productAdditionalInfo, productFeatures;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, fetchGroup(this.productId)];
                    case 1:
                        productAdditionalInfo = _a.sent();
                        return [4, fetchGroupFeatures(this.productId)];
                    case 2:
                        productFeatures = _a.sent();
                        this.product = __assign(__assign({}, this.product), { uniqueSellingPoint: (productAdditionalInfo === null || productAdditionalInfo === void 0 ? void 0 : productAdditionalInfo.uniqueSellingPoint) || '', features: (productFeatures || []).map(function (f) { return f.text || f.header; }) });
                        return [2];
                }
            });
        });
    };
    ProductItemComponent.$inject = ['$q'];
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ProductItemComponent.prototype, "applePayV2Enabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ProductItemComponent.prototype, "googlePayEnabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductItemComponent.prototype, "contactSupportConfigurations", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductItemComponent.prototype, "mode", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductItemComponent.prototype, "product", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ProductItemComponent.prototype, "productType", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductItemComponent.prototype, "showSpecialOffers", void 0);
    ProductItemComponent = __decorate([
        Component({
            selector: 'productItem',
            template: template,
        }),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], ProductItemComponent);
    return ProductItemComponent;
}());
export { ProductItemComponent };
